'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Navbar = require('../../Navbar.js');
require('./NavbarProfile.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavbarProfile = function () {
    var _a = Navbar.useNavbarContext(), isAuthenticated = _a.isAuthenticated, mobileloginAction = _a.mobileloginAction;
    if (isAuthenticated || !mobileloginAction) {
        return (React__default['default'].createElement(React__default['default'].Fragment, null));
    }
    return (React__default['default'].createElement("a", { className: "np-root", title: "Login", href: '#login', onClick: function (e) {
            e.preventDefault();
            mobileloginAction();
        } },
        React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--profile" })));
};

exports.NavbarProfile = NavbarProfile;
//# sourceMappingURL=NavbarProfile.js.map
